// extracted by mini-css-extract-plugin
module.exports = {"layout":"YAPkGTqx","extendContentToHeader":"de3ExMbU","header":"srUvmzmE","content":"HeekPO1i","topBar":"MYLD0f_u","sideNav":"B5E2qJr2"};